import { RECOMMENDATION_KINDS, RECOMMENDATION_STATES, type RecommendationFilters } from '@ederest/contracts';
import { RECOMMENDATION_STATE_LABEL } from '../../shared/guidance/labels.js';
import '../../shared/ui/filters.css';

export type QueueFilters = Pick<RecommendationFilters, 'state' | 'kind'>;

const KIND_LABEL: Record<(typeof RECOMMENDATION_KINDS)[number], string> = {
  guidance: 'Guidance à afficher',
  platform_change: 'Modification du site',
};

/** One parameter per criterion (technical §11.2): state of the decision, kind of recommendation. */
export function RecommendationFilterBar({
  value,
  onChange,
}: {
  value: QueueFilters;
  onChange: (next: QueueFilters) => void;
}) {
  return (
    <div className="filters" role="group" aria-label="Filtres de la file des recommandations">
      <label className="filters__field">
        <span>Décision</span>
        <select
          aria-label="Filtrer par état"
          value={value.state ?? ''}
          onChange={(e) =>
            onChange({ ...value, state: (e.target.value || undefined) as QueueFilters['state'] })
          }
        >
          <option value="">Toutes</option>
          {RECOMMENDATION_STATES.map((state) => (
            <option key={state} value={state}>
              {RECOMMENDATION_STATE_LABEL[state].text}
            </option>
          ))}
        </select>
      </label>
      <label className="filters__field">
        <span>Nature</span>
        <select
          aria-label="Filtrer par nature"
          value={value.kind ?? ''}
          onChange={(e) =>
            onChange({ ...value, kind: (e.target.value || undefined) as QueueFilters['kind'] })
          }
        >
          <option value="">Toutes</option>
          {RECOMMENDATION_KINDS.map((kind) => (
            <option key={kind} value={kind}>
              {KIND_LABEL[kind]}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
}
